import { useHall } from '$logic/hall/react-hook'
import { WithQueryTitleWrapper } from '$common/room-list-search/with-query-title-wrapper/with-query-title-wrapper'
import { WithQueryTitleBase } from '../with-query-title-base'

export function WithQueryHallListItemTitle({
  hallId,
  query,
}: {
  hallId: string
  query: string
}) {
  const { entity: hall } = useHall(hallId)
  const title = hall?.name || ''

  return (
    <WithQueryTitleWrapper>
      <WithQueryTitleBase query={query} title={title} variant="subtitle3" />
    </WithQueryTitleWrapper>
  )
}
